import { FC, ReactNode } from 'react';
import classNames from 'classnames';
import BasicLayout from './basic';
import styles from './page.less';


type TabItem = {
  key: UKey;
  title: ReactNode;
  count?: number;
}

type PageLayoutProps = {
  title?: ReactNode;
  info?: ReactNode;
  notification?: string | string[];
  extra?: ReactNode;
  footer?: ReactNode;
  tabs?: TabItem[];
  activeKey?: UKey;
  loading?: boolean,
  onTabChange?: (key: UKey) => void;
  onBack?: () => void;
  children: ReactNode;
}

const renderNotification = (notice: ReactNode) =>
  <div className={styles.notice}>
    {notice}
  </div>

const PageLayout: FC<PageLayoutProps> = ({ title, info, notification, extra, footer, tabs, activeKey, loading, onTabChange, onBack, children }) =>
  <BasicLayout loading={loading}>
    {(info || extra || onBack || title || notification) ? (
      <header className={styles.header}>
        {(info || extra || onBack) && (
          <nav className={styles.nav}>
            <div className={styles.info}>
              {onBack && <button className={styles.backButton} onClick={onBack}>返回</button>}
              {info}
            </div>
            <div>{extra}</div>
          </nav>
        )}
        {title && (
          typeof title === 'string' ?
            <h2 className={styles.title}>{title}</h2>
            : <div className={styles.title}>{title}</div>
        )}
        {notification &&
          <div className={styles.noticeWrapper}>
            {(notification instanceof Array) ? notification.map(renderNotification)
              : renderNotification(notification)}
          </div>
        }
      </header>
    ) : null}
    {tabs && tabs.length > 0 && (
      <section className={styles.tabs}>
        {tabs.map(
          ({ key, title, count = 0 }) =>
            <span key={key}
              className={classNames(
                styles.tabItem,
                { [styles.active]: key === activeKey }
              )}
              onClick={key === activeKey ? undefined : () => onTabChange(key)}
            >
              <span className={styles.itemTitle}>{title}</span>
              <span className={styles.count}>({count || 0})</span>
            </span>
        )}
      </section>
    )}
    <article className={styles.container}>{children}</article>
    {footer && <footer className={styles.footer}>{footer}</footer>}
  </BasicLayout>

export default PageLayout;